export default "__VITE_ASSET__XUh4Arly__"